import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';

import md5 from 'md5';
import cookie from 'react-cookies';

import Language from './languages';
import Config from './config';

import Login from './views/Auth/Login';
import Forgotten from './views/Auth/Forgotten';
import DefaultLayout from './containers/DefaultLayout/';

class Auth extends Component {
 constructor(props) {
  super(props);

  this.state = {
   token: false,
   uuid: cookie.load('uuid'),
   user: { ID: null, name: null },
   language: cookie.load('language')? cookie.load('language'): 'es_ES',
   permissions: {}
  };

  this.reqAPI = this.reqAPI.bind(this);
  this.getLogin = this.getLogin.bind(this);
  this.getOut = this.getOut.bind(this);
  this.getUserToken = this.getUserToken.bind(this);
  this.changeLanguage = this.changeLanguage.bind(this);

  setInterval(this.getUserToken, 60000);
 }

 reqAPI(route, method, params) {
  var headers = { 'accept': 'application/json' }
  var options = { method: 'GET', headers }
  if (this.state.token) headers['authorization-token'] = this.state.token;

  if (method !== undefined) {
   options = { method, headers, body: JSON.stringify(params) }
  }

  return new Promise((fulfill, reject) => {
   fetch(route, options).then((response) => {
    if (response.status === 401) toast.error(Language[this.state.language].Unauthorized, { autoClose: 15000 });
    if (response.status !== 200) throw new Error("Invalid response");
    return response.json()
   }).then((response) => {
    fulfill(response);
   }).catch((error) => {
    reject({ success: false, message: error });
   })
  })
 }

 getLogin(email, password) {
  return new Promise((fulfill, reject) => {
   this.reqAPI(Config.apiURI + '/api/user/login', 'POST', { email, password: md5(password), uuid: this.state.uuid }).then((response) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 31);
    if (response.uuid && response.token) {
     cookie.save('uuid', response.uuid, { path: '/', expires });
     cookie.save('language', response.language, { path: '/', expires });
     this.setState({ user: { ID: response.user_id, name: response.username }, uuid: response.uuid, token: response.token, language: response.language }, function () { this.getUserToken() });
     fulfill(response);
    } else if (response.token) {
     cookie.save('language', response.language, { path: '/', expires });
     this.setState({ user: { ID: response.user_id, name: response.username }, token: response.token, language: response.language }, this.getUserToken().bind(this));
     fulfill(response);
    } else {
     reject(response);
    }
   }).catch((error) => {
    reject(error);
   })
  })
 }

 getOut() {
  this.reqAPI(Config.apiURI + '/api/user/logout', 'POST', { token: this.state.token }).then((response) => {
   cookie.remove('uuid', { path: '/' });
   this.setState({ user: null, uuid: null, token: false, permissions: {} });
  })
 }

 getUserToken() {
  this.reqAPI(Config.apiURI + '/api/user/token', 'POST', { uuid: this.state.uuid, permissions: true }).then((response) => {
   if (response.token) {
    this.setState({ user: { ID: response.user_id, name: response.username }, token: response.token, permissions: Buffer.from(response.permissions, "base64").toString() });
   } else {
    this.setState({ user: null, token: false, permissions: {} });
   }
  })
 }

 changeLanguage(language) {
  const expires = new Date();
  expires.setDate(expires.getDate() + 31);
  cookie.save('language', language, { path: '/', expires });
  window.location.reload();
 }

 componentDidMount() {
  this._isMounted = true;
  if (this.state.uuid) this.getUserToken();
 }

 componentWillUnmount() {
  this._isMounted = false;
 }

 render() {
  return (
   <BrowserRouter>
    {
     this.state.uuid ?
      <Switch>
       <Route index render={
        (props) =>
         this.state.token && Object.keys(this.state.permissions).length > 0
          ? <DefaultLayout session={{ user: this.state.user, language: this.state.language, permissions: JSON.parse(this.state.permissions) }} changeLanguage={this.changeLanguage} reqAPI={this.reqAPI} getOut={this.getOut} {...props} />
          : <Login session={{language: this.state.language}} changeLanguage={this.changeLanguage} getLogin={this.getLogin} {...props} />
       } />
      </Switch>
      :
      <Switch>
       <Route path="/login" render={(props) => <Login session={{language: this.state.language}} changeLanguage={this.changeLanguage} getLogin={this.getLogin} {...props} />} />
       <Route path="/forgotten" render={(props) => <Forgotten session={{language: this.state.language}} reqAPI={this.reqAPI} {...props} />} />
       <Redirect to="/login" />
      </Switch>
    }
   </BrowserRouter>
  )
 }
}

export default Auth;



// WEBPACK FOOTER //
// ./websources/auth.js